import { Button } from '@glplus/glpweb-dsl';
import type { ComponentProps } from 'react';
import { runnerTheme, type RunnerTopic } from '../styles/runnerTheme';

type Props = Omit<ComponentProps<typeof Button>, 'variant' | 'fullWidth' | 'color' | 'textColor' | 'borderColor' | 'sx'> & {
  topic?: RunnerTopic;
  appearance?: 'outline' | 'primary';
  alignment?: 'center' | 'inline';
};

/** Actions share the label-sized, capped outline treatment on every screen. */
export function RunnerAction({ topic = 'orders', appearance = 'outline', alignment = 'center', ...props }: Props) {
  const primary = appearance === 'primary';
  const color = primary ? runnerTheme.white : runnerTheme.topics[topic].link;
  const border = primary ? runnerTheme.orange : color;
  return <Button {...props} variant={primary ? 'contained' : 'outlined'} borderColor={border} textColor={color} sx={{
    backgroundColor: primary ? runnerTheme.orange : runnerTheme.white, borderColor: border, color, boxShadow: 'none',
    width: 'fit-content', maxWidth: 'min(280px, 100%)', minHeight: 44,
    alignSelf: alignment === 'center' ? 'center' : 'auto', display: 'flex', mx: alignment === 'center' ? 'auto' : 0, px: 2, py: 1, borderRadius: '8px',
    fontFamily: 'var(--font-sans)', fontSize: '14px', fontWeight: 600,
    lineHeight: 1.45, whiteSpace: 'normal', overflowWrap: 'anywhere',
    '&:hover': { borderColor: border, backgroundColor: primary ? runnerTheme.orange : runnerTheme.topics[topic].wash, boxShadow: 'none' },
  }} />;
}
